<template>
  <v-container fluid class="blocks">
    <v-layout row>
      <v-flex xs6 order-lg2>
        <v-card dark tile flat color="red darken-4">
          <component :is="name"></component>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card dark tile flat color="red darken-4">
          <v-card-text>#2</v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import H1Block from '@/components/H1Block.vue'
export default {
  name: 'blocks',
  data : function() {
    return {
      name: 'h1-block',
      blocks: [
        {name: 'h1-block'}
      ]
    }
  },
  components: {
    'h1-block': H1Block
  }

}
</script>
<style scope>
.blocks {
  background: #7F7FD5;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to bottom, #91EAE4, #86A8E7, #7F7FD5);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to bottom, #91EAE4, #86A8E7, #7F7FD5); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
</style>
